import { defineComponent as _defineComponent } from 'vue'
import {QuizTestAttempt} from '@/modules/bhp/models/QuizTest';
import GoToService from '@/router/GoToService';
import LTimerPill from '@/components/commons/LTimerPill.vue';
import DateUtils from '@/services/utils/DateUtils';
import {computed, ref, watchEffect} from 'vue';
import {QuizCategory} from '@/models/Quiz';
import AuthService from '@/modules/user/AuthService';
import moment from 'moment/moment';
import {capitalize} from '@/filters/StringFilters';

type QuizInfoConfig = {
  pathToIcon?: string;
  quizTitle: string;
  quizDescription: string;
  quizDuration: string;
  approvedText: string;
  showTestBtn: boolean;
  tooltipTextRequireTest: () => string;
  tooltipTitleRequireTest: () => string;
  tooltipText: () => string;
  tooltipTitle: () => string;
  tooltipDescription: string;
  startTestBtnText: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QuizCard',
  props: {
    lastPositiveAttempt: null,
    category: null
  },
  setup(__props: any) {

const props = __props as {
  lastPositiveAttempt?: QuizTestAttempt,
  category: QuizCategory,
}


// ten komponent bedzie generyczny w nastepnym tasku, teraz jest cisnienie
const onTakeQuiz = () => {
  GoToService[props.category]();
};

const handleHRlockTimerEnded = () => {
  hasHrLockTimerEnded.value = true;
}

const hasHrLockTimerEnded = ref(false)

const getRequireHrLockAt = (category: QuizCategory) => {
  return AuthService.User?.quiz?.[`require${capitalize(category)}HrLockAt`]!
};

const getRequireQuiz = (category: QuizCategory) => {
  return AuthService.User?.quiz?.[`require${capitalize(category)}`]!
};

const quizInfoConfig: Partial<Record<QuizCategory,QuizInfoConfig>> = {
  [QuizCategory.STMT]: {
    quizTitle: 'Oświadczenia akredytacyjne',
    quizDuration: 'Zajmie 2 minuty',
    pathToIcon: '@/assets/icons/quizes/statements.svg',
    approvedText: 'Potwierdzone',
    showTestBtn: true,
    startTestBtnText: 'Uzupełnij',
    tooltipTextRequireTest: () => 'Po przekroczeniu terminu dostęp do systemu zostanie zablokowany',
    tooltipTitleRequireTest: () => `Ostateczny termin potwierdzenia: ${DateUtils.getFormatedDate(getRequireHrLockAt(props.category))}`,
    tooltipText: () => `Możliwość potwierdzenia będzie dostępna przez ${DateUtils.diff(props.lastPositiveAttempt?.hrLockAt!, props.lastPositiveAttempt?.allowReattemptAt!, 'days',)} dni. W przypadku braku potwierdzenia po tym czasie system zostanie zablokowany.`,
    tooltipTitle: () => `Kolejna możliwość zdania testu: ${DateUtils.getFormatedDate(props.lastPositiveAttempt?.allowReattemptAt!)}`,
    quizDescription: 'Potwierdzenie możliwości dalszego wykonywania zawodu eksperta finansowego',
    tooltipDescription: 'Z uwagi na obowiązki wynikające z przepisów prawa, a także z zawartych umów z bankami, zobowiązany jesteś do złożenia oświadczeń na Platformie Lendi. W przypadku braku potwierdzenia w wyznaczonym terminie, Twoja umowa z Lendi Sp. z o.o. zostanie rozwiązana. Oświadczenia odnawiane są cyklicznie – nie częściej niż raz w roku.',
  },
  [QuizCategory.ETHIC]: {
    quizTitle: 'Szkolenie Etyka i Bezpieczeństwo w sektorze finansowym.',
    pathToIcon: '@/assets/icons/quizes/ethic.svg',
    quizDuration: 'Zajmie 45 minut',
    approvedText: 'Zdane',
    showTestBtn: false,
    startTestBtnText: 'Rozpocznij',
    tooltipTextRequireTest: () => 'Po przekroczeniu terminu dostęp do systemu zostanie zablokowany',
    tooltipTitleRequireTest: () => `Ostateczny termin zdania: ${DateUtils.getFormatedDate(getRequireHrLockAt(props.category))}`,
    tooltipText: () => `Możliwość zdania będzie dostępna przez ${DateUtils.diff(props.lastPositiveAttempt?.hrLockAt!, props.lastPositiveAttempt?.allowReattemptAt!, 'days',)} dni. W przypadku braku zdania po tym czasie system zostanie zablokowany.`,
    tooltipTitle: () => `Kolejna możliwość zdania testu: ${DateUtils.getFormatedDate(props.lastPositiveAttempt?.allowReattemptAt!)}`,
    quizDescription: 'Niezbędne do spełniania wymogów Lendi i instytucji finansowych, koncentruje się na kluczowych zasadach etycznych oraz najlepszych praktykach w zakresie ochrony danych i zarządzania ryzykiem',
    tooltipDescription:  'Z uwagi na obowiązki wynikające z przepisów prawa, a także z zawartych umów z bankami, zobowiązany jesteś do realizacji szkoleń udostępnianych na Platformie Lendi. W przypadku braku zdania w wyznaczonym terminie, Twoja umowa z Lendi Sp. z o.o. zostanie rozwiązana. Szkolenia odnawiane są cyklicznie – nie częściej niż raz w roku.',
  },
}


return { __sfc: true,props, onTakeQuiz, handleHRlockTimerEnded, hasHrLockTimerEnded, getRequireHrLockAt, getRequireQuiz, quizInfoConfig, LTimerPill, DateUtils, moment }
}

})